// extracted by mini-css-extract-plugin
export default {"wrapper":"formInput_wrapper__W6kYK","inputBox":"formInput_inputBox__k6F2a","input":"formInput_input__RZWjR","floatingLabel":"formInput_floatingLabel__PJR3x"};